import React, { useState } from 'react'
import * as Modal from '_components/modal/generic-modal'
import { Grid } from '@material-ui/core'
import { Attachments } from '_/components/refera-ui'
import PreviewComponent from '_components/common/preview-component'
import useStyles from '../styles'

export function EvidenceOfActionModal({
  open,
  setOpenEvidenceOfActionModal,
  attachments,
  setAttachments,
}) {
  const styles = useStyles()

  const [previewState, setPreviewState] = useState({
    open: false,
    selectedIndex: undefined,
  })

  const handlePictureItemClick = index =>
    setPreviewState({
      open: true,
      selectedIndex: index,
    })

  return (
    <>
      <Modal.Root open={open} onClose={() => setOpenEvidenceOfActionModal(false)}>
        <Modal.TitleModal title="Evidência da ação" />

        <Modal.Content>
          <Grid>
            <PreviewComponent
              images={attachments}
              {...previewState}
              setPreviewState={setPreviewState}
            />
            {attachments && (
              <Attachments
                label="Imagens e vídeos"
                readOnly
                files={attachments}
                accept={{
                  'image/jpeg': [
                    '.jpeg',
                    '.png',
                    '.jpg',
                    '.bmp',
                    '.webp',
                    '.mkv',
                    '.mp4',
                    '.mov',
                    '.avi',
                    '.m4v',
                    '.mpg',
                    '.mpeg',
                    '.wmv',
                    '.webm',
                  ],
                }}
                onItemClick={handlePictureItemClick}
                onDrop={fs => setAttachments(fs)}
                className={styles.attachment}
              />
            )}
          </Grid>
        </Modal.Content>
        <Modal.Actions className={styles.buttonsContainer}>
          <Modal.ButtonBlue onClick={() => setOpenEvidenceOfActionModal(false)}>
            Fechar
          </Modal.ButtonBlue>
        </Modal.Actions>
      </Modal.Root>
    </>
  )
}
